/**
 * @flow
 */

import React, { Component } from 'react'
import ResponsiveContainer from '../../core/ResponsiveContainer'
import Section from './components/Section'

import { SectionContainer, Wrapper } from './styledComponents'

class EventsDescriptionSection extends Component {
  renderImageAndContentSection = (event, index) => {
    const {
      eventId,
      title,
      description,
      mainImage,
      mobileImage,
      buttonText
    } = event
    console.log("hi radha",event);
    return (
      <Section
        id={eventId.toLowerCase()}
        key={title}
        futureItemDescription={description}
        futureItemTitle={title}
        imagePosition={index % 2 === 0 ? 'RIGHT' : 'LEFT'}
        mainImage={mainImage}
        mobileImage={mobileImage}
        buttonText={buttonText}
      />
    )
  }

  render() {
    const { eventsSection: { eventsSectionId, eventsList } } = this.props

    return (
      <SectionContainer id={eventsSectionId}>
        <ResponsiveContainer>
          <Wrapper>
            {eventsList.map((event, index) =>
              this.renderImageAndContentSection(event, index)
            )}
          </Wrapper>
        </ResponsiveContainer>
      </SectionContainer>
    )
  }
}
export default EventsDescriptionSection



// WEBPACK FOOTER //
// ./src/components/Events/EventsDescriptionSection/index.js